/**
 * Indexed Search Autocomplete
 *
 * Toggles "show more/lesse" on content elements
 */

(function Autocomplete() {

    let indexedSearchAutocompleteDebounceInterval = null; // Used to reduce the amount of querys
    const $searchField = $('.indexed-search-autocomplete-sword');
    const $resultField = $('.search-autocomplete-results');
    const $overlay = $('.overlay');
    const _resultTextLengthBefore = typeof $resultField.data('textlength-before') === 'undefined' ? 20 : $resultField.data('textlength-before');
    const _resultTextLengthAfter = typeof $resultField.data('textlength-after') === 'undefined' ? 10 : $resultField.data('textlength-after');

    function initIndexSearchAutocomplete() {
        $searchField.on('keypress keyup', indexedSearchAutocomplete).attr('autocomplete', 'off');

        $('*').click(function (event) {
            let elem = $(this);
            let targetClass = '.search-autocomplete-results';

            if ($resultField.hasClass('results') && event.target.className == 'indexed-search-autocomplete-sword') {
                return; // Keep Result-Div opened
            }

            if ($resultField.find('*').length == 0) {
                return; // Result-Div is not shown
            }

            while (elem.prop('tagName') != 'HTML' && !elem.hasClass(targetClass)) {
                elem = elem.parent();
            }

            if (elem.prop('tagName') == 'HTML') {
                $(targetClass).html('').hide().removeClass('results').addClass('no-results');

                if ($overlay.length > 0) {
                    $overlay.removeClass('is-active');
                }
            }
        });

        $searchField
            .data('current-text', $searchField.val())
            .on('focus', function () {
                if (!$resultField.hasClass('results')) {
                    $searchField.val('')
                }
            })
            .on('blur', function () {
                if (!$resultField.hasClass('results')) {
                    $searchField.val($searchField.data('current-text'))
                }
            });
    }

    function indexedSearchAutocomplete(e) {
        if ($resultField.length == 0) {
            console.log("we couldn't find a result div (.search-autocomplete-results)");
            return;
        }

        // navigate through the suggestion-results
        if (e.which === 38 || e.which === 40 || e.keyCode === 10 || e.keyCode === 13) { // up / down / enter

            if (e.which === 38 && e.type === 'keyup') { // up
                let $prev = $resultField.find('li.highlighted').prev();

                if ($resultField.find('li.highlighted').length === 0 || $prev.length === 0) {
                    $resultField.find('li.highlighted').removeClass('highlighted');
                    $resultField.find('li').last().addClass('highlighted');
                    return;
                }

                $resultField.find('li.highlighted').removeClass('highlighted');
                $prev.addClass('highlighted');
            }

            if (e.which === 40 && e.type === 'keyup') { // down
                let $next = $resultField.find('li.highlighted').next();

                if ($resultField.find('li.highlighted').length === 0 || $next.length === 0) {
                    $resultField.find('li.highlighted').removeClass('highlighted');
                    $resultField.find('li').first().addClass('highlighted');
                    return;
                }

                $resultField.find('li.highlighted').removeClass('highlighted');
                $next.addClass('highlighted');
            }

            if ((e.keyCode === 10 || e.keyCode === 13) && e.type === 'keypress') { // enter
                if ($resultField.is(':visible') && $resultField.find('li.highlighted').length > 0) {
                    window.location = $resultField.find('li.highlighted a.navigate-on-enter').attr('href');
                    e.preventDefault();
                }
            }

            return;
        }

        if (e.type !== 'keyup') {
            return;
        }

        $resultField.html('').hide().removeClass('results').addClass('no-results');

        let val = $(this).val();
        let minlen = typeof $resultField.data('minlength') === 'undefined' ? 3 : $resultField.data('minlength');

        if (val.length < minlen) {
            return;
        }

        $resultField.addClass('autocomplete_searching');

        // Debounce
        clearInterval(indexedSearchAutocompleteDebounceInterval);

        indexedSearchAutocompleteDebounceInterval = setInterval(function() {
            clearInterval(indexedSearchAutocompleteDebounceInterval);

            // Execute the query
            $.ajax({
                url: $('#tx_indexedsearch').attr('action') + '?type=7423794',
             cache: false,
                method: 'POST',
                data: $('#tx_indexedsearch').serialize(),
                success: function (data) {
                    let resultData = getFormattedResultList($(data));

                    $resultField
                        .show()
                        .html(resultData.html())
                        .removeClass('autocomplete_searching')
                        .find('.search__result');

                    if ($resultField.find('li').length == 0) {
                        $resultField.html('').hide();
                        $resultField.removeClass('results').addClass('no-results');

                        if ($overlay.length > 0) {
                            $overlay.removeClass('is-active');
                        }
                    } else {
                        $resultField.removeClass('no-results').addClass('results');

                        if ($overlay.length > 0) {
                            $overlay.addClass('is-active');
                        }
                    }
                }
            });
        }, 250);
    }

    function getFormattedResultList(resultData) {
        let items = resultData.find('.search__result');
        let fullList = $('<div><ul></ul></div>');

        $.each(items, function(i, element) {
            let item = $('<li><h4></h4><div class="matches"></div></li>');
            let searchResult = $(element);
            let header = searchResult.find('h3');

            item.find('h4').append(header.html());

            let found = searchResult.find('.tx-indexedsearch-redMarkup');

            $.each(found, function(i, match) {
                let matchResult = $(match);
                let textBefore = matchResult[0].previousSibling.data;
                let textAfter = matchResult[0].nextSibling.data;
                let description = '...' + textBefore.substr(textBefore.length - _resultTextLengthBefore) + '<span>' +  matchResult.text() + '</span>' + textAfter.substr(0, _resultTextLengthAfter) + '...';

                item.find('.matches').append(description + '<br />');
                fullList.children('ul').append(item);
            });
        });

        return fullList;
    }

    if ($searchField.length > 0 && $resultField.length > 0) {
        initIndexSearchAutocomplete();
    }
})();